<header class="mobile appointment">
  <div>
    <mat-icon svgIcon="ss-logo" class="logo-img"></mat-icon>
  </div>
  <div style="color: white">
    {{ "MAIN_APP_PENDENZEN_TERMIN.termine" | translate }}
  </div>
  <div class="burger-menu">
    <button ejs-speeddial id="speedDialMenu" openIconCss="e-icons e-menu" closeIconCss="e-icons e-close" position="TopRight" (created)="speedMenuCreated()" (clicked)="speedMenuClicked($event)" [items]="menuItems"></button>
  </div>
</header>


<main>
  <ejs-schedule #scheduleObj [timeFormat]="timeFormat" locale="de-CH" [dateFormat]="dateFormat" [firstDayOfWeek]="1" width="100%" height="100%" [selectedDate]="selectedDate" [group]="group" [eventSettings]="eventSettings" (popupOpen)="onPopupOpen($event)" (popupClose)="onPopupClose($event)"
    (eventClick)="onEventClick($event)" (dragStop)="onDragStopEvent($event)" [showQuickInfo]="showQuickInfo">
    <e-views>
      <e-view option="Week" startHour="07:00" endHour="20:00"></e-view>
      <e-view option="WorkWeek" startHour="07:00" endHour="20:00" isSelected="true"></e-view>
      <e-view option="Month" [showWeekend]="showWeekend"></e-view>
    </e-views>
    <e-resources>
      <e-resource field="UserName" title="Mitarbeiter" name="Mitarbeiter" [dataSource]="mitarbeiterDataSource" [allowMultiple]="allowMultipleOwner" textField="Mitarbeiter" idField="UserName" colorField="Farbe">
      </e-resource>
    </e-resources>
  </ejs-schedule>

</main>
